/* Dion Wear 2.0 product page: variant resolution, gallery, size guide (no image zoom: owner 2026-10-19).
   Add to cart itself is handled by Venue's <product-form> element. */
(() => {
  const root = document.querySelector('[data-dw-pdp]');
  if (!root || root.dataset.dwReady) return;
  root.dataset.dwReady = '1';

  const data = JSON.parse(root.querySelector('[data-dw-product-json]').textContent);
  const variants = data.variants;
  const optionCount = data.options.length;
  const groups = [...root.querySelectorAll('[data-dw-option]')];
  const idInput = root.querySelector('[data-dw-variant-input]');
  const atc = root.querySelector('[data-dw-atc]');
  const atcLabel = root.querySelector('[data-dw-atc-label]');
  const status = root.querySelector('[data-dw-status]');
  const dynamic = root.querySelector('[data-dw-dynamic]');
  const nowEl = root.querySelector('[data-dw-now]');
  const wasEl = root.querySelector('[data-dw-was]');
  const saleBadge = root.querySelector('[data-dw-salebadge]');
  const sizeName = data.sizeIndex > -1 ? data.options[data.sizeIndex].toLowerCase() : 'size';

  // ---- Money ---------------------------------------------------------------
  const fmt = (cents) => {
    const tpl = data.moneyFormat || '${{amount}}';
    const n = (cents / 100);
    const withDelims = (num, dec, thou, sep) => {
      const [i, d] = num.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? sep + d : '');
    };
    return tpl.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        default: return withDelims(n, 2, ',', '.');
      }
    });
  };

  // ---- Selection state -----------------------------------------------------
  const selection = () => groups.map((g) => {
    const c = g.querySelector('input:checked');
    return c ? c.value : null;
  });

  const matches = (v, sel, skip = -1) => sel.every((val, i) => i === skip || val === null || v.options[i] === val);

  const findVariant = (sel) => {
    if (variants.length === 1 && optionCount <= 1 && groups.length === 0) return variants[0];
    if (sel.some((s) => s === null)) return null;
    return variants.find((v) => v.options.every((o, i) => o === sel[i])) || null;
  };

  const applySelectionToInputs = (values) => {
    groups.forEach((g, i) => {
      g.querySelectorAll('input').forEach((inp) => { inp.checked = values[i] !== null && inp.value === values[i]; });
    });
  };

  // ---- Render --------------------------------------------------------------
  let lastMedia = null;

  const render = ({ fromUser = false } = {}) => {
    const sel = selection();
    const variant = findVariant(sel);

    // Option labels + per-value availability given the other selected options
    groups.forEach((g, i) => {
      const label = g.querySelector('[data-dw-option-label]');
      if (label) label.textContent = sel[i] || '';
      g.querySelectorAll('input').forEach((inp) => {
        const ok = variants.some((v) => v.available && v.options[i] === inp.value && matches(v, sel, i));
        const exists = variants.some((v) => v.options[i] === inp.value && matches(v, sel, i));
        const lab = root.querySelector(`label[for="${CSS.escape(inp.id)}"]`);
        if (!lab) return;
        lab.classList.toggle('is-unavailable', !ok);
        const sr = lab.querySelector('[data-dw-unavail-label]');
        if (sr) sr.textContent = ok ? '' : exists ? '(sold out)' : '(unavailable)';
      });
    });

    // Price
    if (variant) {
      nowEl.textContent = fmt(variant.price);
      const onSale = variant.compare > variant.price;
      nowEl.classList.toggle('is-sale', onSale);
      wasEl.hidden = !onSale;
      if (onSale) wasEl.lastChild.textContent = fmt(variant.compare);
      saleBadge.hidden = !onSale;
    } else {
      const pool = variants.filter((v) => matches(v, sel));
      const prices = (pool.length ? pool : variants).map((v) => v.price);
      const min = Math.min(...prices), max = Math.max(...prices);
      nowEl.textContent = min === max ? fmt(min) : `${fmt(min)} – ${fmt(max)}`;
      const anySale = (pool.length ? pool : variants).some((v) => v.compare > v.price);
      nowEl.classList.toggle('is-sale', anySale);
      wasEl.hidden = true;
      saleBadge.hidden = !anySale;
    }

    // Button + hidden id
    let label = 'Add to cart', disabled = false, msg = '';
    if (!variants.some((v) => v.available)) {
      label = 'Sold out';
      msg = 'This product is sold out.';
      disabled = true;
    } else if (!variant) {
      const missing = groups.findIndex((g, i) => sel[i] === null);
      if (missing > -1) {
        label = `Select a ${data.options[missing].toLowerCase()}`;
      } else {
        label = 'Unavailable';
        msg = 'This combination is not available.';
      }
      disabled = true;
    } else if (!variant.available) {
      label = 'Sold out';
      msg = 'This option is sold out.';
      disabled = true;
    }
    idInput.value = variant && variant.available ? variant.id : '';
    atc.disabled = disabled;
    atcLabel.textContent = label;
    status.textContent = msg;
    if (dynamic) dynamic.classList.toggle('is-hidden', disabled);

    // URL: keep ?variant= in sync (replaceState, so Back/Forward stays page-level)
    try {
      const url = new URL(location.href);
      if (variant) url.searchParams.set('variant', variant.id);
      else url.searchParams.delete('variant');
      if (url.href !== location.href) history.replaceState(history.state, '', url);
    } catch (e) { /* URL sync is best-effort; never block the purchase UI */ }

    // Variant-aware gallery: image 01 shows the selected colour; a colour change returns to image 01
    if (vg) {
      const color = sel[vg.colorIndex];
      if (color && color !== vg.current && vg.colors[color]) {
        vgSetColor(color);
        gallery.goTo(0, false); // instant: an interrupted smooth scroll could leave the counter and slide out of sync
      }
      return;
    }

    // Gallery: jump to the variant's own image when it changes
    const media = variant ? variant.media : (() => {
      // No full variant yet (e.g. size not chosen): use the selected colour's image
      const v = variants.find((x) => matches(x, sel) && x.media);
      return v ? v.media : null;
    })();
    if (media && media !== lastMedia) {
      lastMedia = media;
      if (fromUser) gallery.goToMedia(media);
    }
  };

  // Initial state: URL variant wins, otherwise the server-rendered checked inputs
  const syncFromUrl = () => {
    const id = Number(new URL(location.href).searchParams.get('variant'));
    const v = id && variants.find((x) => x.id === id);
    if (v && groups.length) applySelectionToInputs(v.options);
  };

  groups.forEach((g) => g.addEventListener('change', () => render({ fromUser: true })));

  // ---- Quantity ------------------------------------------------------------
  const qty = root.querySelector('.dw-qty__input');
  root.querySelectorAll('[data-dw-qty-step]').forEach((b) => b.addEventListener('click', () => {
    const next = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.dwQtyStep));
    qty.value = next;
  }));
  qty.addEventListener('change', () => { qty.value = Math.max(1, parseInt(qty.value, 10) || 1); });

  // ---- Variant-aware gallery data -------------------------------------------
  // One shared image list per design; only image 01 (the colour's own image) changes with the colour.
  const vgJson = root.querySelector('[data-dw-vg-json]');
  const vg = vgJson ? JSON.parse(vgJson.textContent) : null;
  const vgSetColor = (color) => {
    const c = vg.colors[color];
    const img = root.querySelector('[data-dw-vg-main] img');
    if (img) {
      img.srcset = c.srcset;
      img.src = c.src;
      img.alt = c.alt;
    }
    const thumb = root.querySelector('[data-dw-thumb="0"] img');
    if (thumb) thumb.src = c.thumb;
    vg.current = color;
  };

  // ---- Gallery -------------------------------------------------------------
  const gallery = (() => {
    const track = root.querySelector('[data-dw-track]');
    const slides = track ? [...track.children] : [];
    const thumbs = [...root.querySelectorAll('[data-dw-thumb]')];
    const count = root.querySelector('[data-dw-count]');
    const strip = root.querySelector('[data-dw-thumbs]');
    const stripPrev = root.querySelector('[data-dw-strip-prev]');
    const stripNext = root.querySelector('[data-dw-strip-next]');
    let index = 0;

    // Strip arrows: only shown when there is more to scroll in that direction
    const updateStripButtons = () => {
      if (!strip || !stripPrev) return;
      const max = strip.scrollWidth - strip.clientWidth;
      // small tolerance: the strip has 2px padding for the selected ring
      stripPrev.hidden = strip.scrollLeft <= 4;
      stripNext.hidden = strip.scrollLeft >= max - 4;
    };
    if (strip && stripPrev) {
      const page = (dir) => strip.scrollBy({ left: dir * strip.clientWidth * 0.8, behavior: 'smooth' });
      stripPrev.addEventListener('click', () => page(-1));
      stripNext.addEventListener('click', () => page(1));
      strip.addEventListener('scroll', updateStripButtons, { passive: true });
      window.addEventListener('resize', updateStripButtons);
      updateStripButtons();
    }

    const setActive = (i) => {
      index = i;
      thumbs.forEach((t, k) => t.toggleAttribute('aria-current', k === i));
      if (count) count.textContent = i + 1;
      // Keep the active thumbnail visible by scrolling the strip only (never the page)
      const t = thumbs[i];
      if (strip && t && strip.offsetParent !== null) {
        const item = t.parentElement;
        const sb = strip.getBoundingClientRect();
        const ib = item.getBoundingClientRect();
        const pad = 6;
        if (ib.left < sb.left) strip.scrollTo({ left: strip.scrollLeft - (sb.left - ib.left) - pad, behavior: 'smooth' });
        else if (ib.right > sb.right) strip.scrollTo({ left: strip.scrollLeft + (ib.right - sb.right) + pad, behavior: 'smooth' });
      }
    };
    const goTo = (i, smooth = true) => {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      setActive(i);
    };
    const goToMedia = (id, smooth = true) => {
      const i = slides.findIndex((s) => Number(s.dataset.mediaId) === Number(id));
      if (i > -1) goTo(i, smooth);
    };

    if (track) {
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== index && slides[i]) setActive(i);
        });
      }, { passive: true });
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      });
    }
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.dwThumb))));
    const prev = root.querySelector('[data-dw-prev]');
    const next = root.querySelector('[data-dw-next]');
    if (prev) prev.addEventListener('click', () => goTo(index - 1));
    if (next) next.addEventListener('click', () => goTo(index + 1));

    return { goTo, goToMedia, get index() { return index; }, size: slides.length };
  })();

  // ---- Size guide ----------------------------------------------------------
  (() => {
    const dlg = root.querySelector('[data-dw-guide]');
    if (!dlg) return;
    root.querySelectorAll('[data-dw-open-guide]').forEach((b) => b.addEventListener('click', () => {
      dlg.showModal();
      document.documentElement.classList.add('dw-noscroll');
    }));
    const unlock = () => document.documentElement.classList.remove('dw-noscroll');
    const close = () => { dlg.close(); unlock(); };
    dlg.querySelector('[data-dw-close-guide]').addEventListener('click', close);
    dlg.addEventListener('click', (e) => { if (e.target === dlg) close(); });
    dlg.addEventListener('cancel', unlock);
    dlg.addEventListener('close', unlock);
  })();

  // ---- Boot ----------------------------------------------------------------
  const boot = () => {
    syncFromUrl();
    render();
    const v = findVariant(selection());
    const startMedia = v ? v.media : lastMedia;
    if (startMedia) gallery.goToMedia(startMedia, false);
  };
  boot();
  // bfcache / Back-Forward: browsers may restore radio state; re-sync with the URL
  window.addEventListener('pageshow', (e) => { if (e.persisted) boot(); });
})();
